import {
  getCommonParamsOptions,
  getGlobalParamsOptionsAsync,
  getParamsOptionsAsync
} from '@/utils/common.js'

export const searchFormConfig = {
  formItems: [
    {
      field: 'terminalId',
      type: 'input',
      label: 'terminal.id'
    },
    {
      field: 'sn',
      type: 'input',
      label: 'terminal.sn'
    },
    {
      field: 'modelId',
      type: 'select',
      label: 'file.model-type',
      isResolveGlobalParams: true,
      options: [],
      handler: () =>
        getGlobalParamsOptionsAsync('terminalModel', {
          isNeedPreFix: false
        })
    },
    {
      field: 'tenantId',
      type: 'treeSelect',
      label: 'user.tenant',
      isResolveGlobalParams: true,
      options: [],
      handler: () => getParamsOptionsAsync('tenantList'),
      isLinkageOptions: true,
      otherOptions: {}
    },
    {
      field: 'status',
      type: 'select',
      label: 'general.status',
      options: [],
      isResolveGlobalParams: true,
      handler: () => getCommonParamsOptions('terminal_status')
    },
    {
      field: 'createTime',
      type: 'datepicker',
      label: 'general.creation-date',
      otherOptions: {
        type: 'daterange'
      },
      dateFieldName: ['startDateTime', 'endDateTime']
    }
  ]
}
